import { render } from "./PartnerInbox.vue?vue&type=template&id=f8958706&scoped=true"
import script from "./PartnerInbox.vue?vue&type=script&lang=js"
export * from "./PartnerInbox.vue?vue&type=script&lang=js"

import "./PartnerInbox.vue?vue&type=style&index=0&id=f8958706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8958706"]])

export default __exports__